import {Action, createReducer, on} from '@ngrx/store';
import {
  MailerDomainsList,
  MailerDomainsListSuccess,
  MailerDomainsListError,
  MailerDomainDelete,
  MailerDomainDeleteSuccess,
  MailerDomainDeleteError,
  MailerDomainCreate,
  MailerDomainCreateSuccess,
  MailerDomainCreateError,
  MailerDomainUpdate,
  MailerDomainUpdateSuccess,
  MailerDomainUpdateError,
  ResetMailerDomainState,
} from '@app/stores/mailer-domain/mailer-domain.actions';
import {initialMailerDomainState} from '@app/stores/mailer-domain/mailer-domain.state';

const generateReducer = createReducer(initialMailerDomainState,
  on(MailerDomainsList, (state) => ({
    ...state,
    paginatedMailerDomains: null,
    success: '',
    error: ''
  })),
  on(MailerDomainsListSuccess, (state, {paginatedMailerDomains}) => ({
    ...state,
    paginatedMailerDomains,
    success: '',
    error: ''
  })),
  on(MailerDomainsListError, (state, {error}) => ({
    ...state,
    paginatedMailerDomains: null,
    success: '',
    error
  })),
  on(MailerDomainDelete, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(MailerDomainDeleteSuccess, (state) => ({
    ...state,
    success: 'Domain deleted successfully',
    error: ''
  })),
  on(MailerDomainDeleteError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(MailerDomainCreate, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(MailerDomainCreateSuccess, (state) => ({
    ...state,
    success: 'Domain added successfully',
    error: ''
  })),
  on(MailerDomainCreateError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(MailerDomainUpdate, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(MailerDomainUpdateSuccess, (state) => ({
    ...state,
    success: 'Domain updated successfully',
    error: ''
  })),
  on(MailerDomainUpdateError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(ResetMailerDomainState, (state, {params}) => ({
    ...state,
    ...params
  })),
);

export function mailerDomainReducer(state = initialMailerDomainState, action: Action) {
  return generateReducer(state, action);
}
